var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-page", { attrs: { padding: "" } }, [
    _c(
      "div",
      { staticClass: "row gutter-sm" },
      [
        _vm.home_banners.length > 0 && _vm.showBanner
          ? _c(
              "div",
              { staticClass: "col-12 q-mb-md carousel-home" },
              [
                _c(
                  "q-carousel",
                  {
                    staticClass: "text-white shadow-3",
                    attrs: {
                      height: _vm.getHeight + "px",
                      infinite: "",
                      autoplay: ""
                    }
                  },
                  _vm._l(_vm.home_banners, function(banner, index) {
                    return _c("q-carousel-slide", {
                      key: index,
                      staticClass: "cursor-pointer background-slide",
                      attrs: { "img-src": banner.image_mobile },
                      nativeOn: {
                        click: function($event) {
                          return _vm.openBanner(banner)
                        }
                      }
                    })
                  }),
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.banners_trainings.length > 0 && _vm.home_banners.length === 0
          ? _c(
              "div",
              { staticClass: "col-12 q-mb-md carousel-home" },
              [
                _c(
                  "q-card",
                  { staticClass: "bg-white" },
                  [
                    _c(
                      "q-card-title",
                      { staticClass: "text-center bg-primary text-white" },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("next_steps")) +
                            "\n                "
                        )
                      ]
                    ),
                    _c("q-card-separator"),
                    _c(
                      "q-card-main",
                      { staticClass: "text-center relative-position" },
                      [
                        _c(
                          "q-carousel",
                          {
                            ref: "carousel",
                            staticClass: "text-white shadow-3",
                            attrs: {
                              height: _vm.getHeight + "px",
                              infinite: "",
                              autoplay: ""
                            }
                          },
                          _vm._l(_vm.banners_trainings, function(
                            banner,
                            index
                          ) {
                            return _c(
                              "q-carousel-slide",
                              {
                                key: index,
                                attrs: { "img-src": banner.image_desktop },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.goToTraining(banner)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "absolute-bottom custom-caption-mobile"
                                  },
                                  [
                                    _c("div", { staticClass: "q-title" }, [
                                      _vm._v(_vm._s(banner.title))
                                    ])
                                  ]
                                )
                              ]
                            )
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._l(_vm.getHomeButtons, function(button, index) {
          return _c(
            "div",
            { key: index, staticClass: "col-6" },
            [
              _c(
                "q-card",
                {
                  staticClass: "bg-primary",
                  staticStyle: {
                    "min-height": "100px",
                    "border-radius": "6px"
                  },
                  nativeOn: {
                    click: function($event) {
                      return _vm.$router.push({ name: button.to })
                    }
                  }
                },
                [
                  _c("div", { staticClass: "row q-pl-md q-pt-md" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 q-mb-sm" },
                      [
                        _c("q-icon", {
                          attrs: {
                            name: button.icon,
                            size: "2rem",
                            color: "white"
                          }
                        })
                      ],
                      1
                    ),
                    _c("div", { staticClass: "col-12 q-title text-white" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t(button.text)) +
                          "\n                    "
                      )
                    ])
                  ])
                ]
              )
            ],
            1
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }